(() => {
  var __create = Object.create;
  var __defProp = Object.defineProperty;
  var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
  var __getOwnPropNames = Object.getOwnPropertyNames;
  var __getProtoOf = Object.getPrototypeOf;
  var __hasOwnProp = Object.prototype.hasOwnProperty;
  var __commonJS = (cb, mod) => function __require() {
    return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
  };
  var __copyProps = (to, from, except, desc) => {
    if (from && typeof from === "object" || typeof from === "function") {
      for (let key of __getOwnPropNames(from))
        if (!__hasOwnProp.call(to, key) && key !== except)
          __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
    }
    return to;
  };
  var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
    // If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
    mod
  ));

  // node_modules/fast-deep-equal/index.js
  var require_fast_deep_equal = __commonJS({
    "node_modules/fast-deep-equal/index.js"(exports, module) {
      "use strict";
      module.exports = function equal2(a, b) {
        if (a === b)
          return true;
        if (a && b && typeof a == "object" && typeof b == "object") {
          if (a.constructor !== b.constructor)
            return false;
          var length, i, keys;
          if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length)
              return false;
            for (i = length; i-- !== 0; )
              if (!equal2(a[i], b[i]))
                return false;
            return true;
          }
          if (a.constructor === RegExp)
            return a.source === b.source && a.flags === b.flags;
          if (a.valueOf !== Object.prototype.valueOf)
            return a.valueOf() === b.valueOf();
          if (a.toString !== Object.prototype.toString)
            return a.toString() === b.toString();
          keys = Object.keys(a);
          length = keys.length;
          if (length !== Object.keys(b).length)
            return false;
          for (i = length; i-- !== 0; )
            if (!Object.prototype.hasOwnProperty.call(b, keys[i]))
              return false;
          for (i = length; i-- !== 0; ) {
            var key = keys[i];
            if (!equal2(a[key], b[key]))
              return false;
          }
          return true;
        }
        return a !== a && b !== b;
      };
    }
  });

  // node_modules/zenscroll/zenscroll.js
  var require_zenscroll = __commonJS({
    "node_modules/zenscroll/zenscroll.js"(exports, module) {
      (function(root, factory) {
        if (typeof define === "function" && define.amd) {
          define([], factory());
        } else if (typeof module === "object" && module.exports) {
          module.exports = factory();
        } else {
          (function install() {
            if (document && document.body) {
              root.zenscroll = factory();
            } else {
              setTimeout(install, 9);
            }
          })();
        }
      })(exports, function() {
        "use strict";
        var isNativeSmoothScrollEnabledOn = function(elem) {
          return elem && "getComputedStyle" in window && window.getComputedStyle(elem)["scroll-behavior"] === "smooth";
        };
        if (typeof window === "undefined" || !("document" in window)) {
          return {};
        }
        var makeScroller = function(container, defaultDuration, edgeOffset) {
          defaultDuration = defaultDuration || 999;
          if (!edgeOffset && edgeOffset !== 0) {
            edgeOffset = 9;
          }
          var scrollTimeoutId;
          var setScrollTimeoutId = function(newValue) {
            scrollTimeoutId = newValue;
          };
          var stopScroll = function() {
            clearTimeout(scrollTimeoutId);
            setScrollTimeoutId(0);
          };
          var getTopWithEdgeOffset = function(elem) {
            return Math.max(0, container.getTopOf(elem) - edgeOffset);
          };
          var scrollToY = function(targetY, duration, onDone) {
            stopScroll();
            if (duration === 0 || duration && duration < 0 || isNativeSmoothScrollEnabledOn(container.body)) {
              container.toY(targetY);
              if (onDone) {
                onDone();
              }
            } else {
              var startY = container.getY();
              var distance = Math.max(0, targetY) - startY;
              var startTime = (/* @__PURE__ */ new Date()).getTime();
              duration = duration || Math.min(Math.abs(distance), defaultDuration);
              (function loopScroll() {
                setScrollTimeoutId(setTimeout(function() {
                  var p = Math.min(1, ((/* @__PURE__ */ new Date()).getTime() - startTime) / duration);
                  var y = Math.max(0, Math.floor(startY + distance * (p < 0.5 ? 2 * p * p : p * (4 - p * 2) - 1)));
                  container.toY(y);
                  if (p < 1 && container.getHeight() + y < container.body.scrollHeight) {
                    loopScroll();
                  } else {
                    setTimeout(stopScroll, 99);
                    if (onDone) {
                      onDone();
                    }
                  }
                }, 9));
              })();
            }
          };
          var scrollToElem = function(elem, duration, onDone) {
            scrollToY(getTopWithEdgeOffset(elem), duration, onDone);
          };
          var scrollIntoView = function(elem, duration, onDone) {
            var elemHeight = elem.getBoundingClientRect().height;
            var elemBottom = container.getTopOf(elem) + elemHeight;
            var containerHeight = container.getHeight();
            var y = container.getY();
            var containerBottom = y + containerHeight;
            if (getTopWithEdgeOffset(elem) < y || elemHeight + edgeOffset > containerHeight) {
              scrollToElem(elem, duration, onDone);
            } else if (elemBottom + edgeOffset > containerBottom) {
              scrollToY(elemBottom - containerHeight + edgeOffset, duration, onDone);
            } else if (onDone) {
              onDone();
            }
          };
          var scrollToCenterOf = function(elem, duration, offset, onDone) {
            scrollToY(Math.max(0, container.getTopOf(elem) - container.getHeight() / 2 + (offset || elem.getBoundingClientRect().height / 2)), duration, onDone);
          };
          var setup = function(newDefaultDuration, newEdgeOffset) {
            if (newDefaultDuration === 0 || newDefaultDuration) {
              defaultDuration = newDefaultDuration;
            }
            if (newEdgeOffset === 0 || newEdgeOffset) {
              edgeOffset = newEdgeOffset;
            }
            return {
              defaultDuration,
              edgeOffset
            };
          };
          return {
            setup,
            to: scrollToElem,
            toY: scrollToY,
            intoView: scrollIntoView,
            center: scrollToCenterOf,
            stop: stopScroll,
            moving: function() {
              return !!scrollTimeoutId;
            },
            getY: container.getY,
            getTopOf: container.getTopOf
          };
        };
        var docElem = document.documentElement;
        var getDocY = function() {
          return window.scrollY || docElem.scrollTop;
        };
        var zenscroll2 = makeScroller({
          body: document.scrollingElement || document.body,
          toY: function(y) {
            window.scrollTo(0, y);
          },
          getY: getDocY,
          getHeight: function() {
            return window.innerHeight || docElem.clientHeight;
          },
          getTopOf: function(elem) {
            return elem.getBoundingClientRect().top + getDocY() - docElem.offsetTop;
          }
        });
        zenscroll2.createScroller = function(scrollContainer, defaultDuration, edgeOffset) {
          return makeScroller({
            body: scrollContainer,
            toY: function(y) {
              scrollContainer.scrollTop = y;
            },
            getY: function() {
              return scrollContainer.scrollTop;
            },
            getHeight: function() {
              return Math.min(scrollContainer.clientHeight, window.innerHeight || docElem.clientHeight);
            },
            getTopOf: function(elem) {
              return elem.offsetTop;
            }
          }, defaultDuration, edgeOffset);
        };
        if ("addEventListener" in window && !window.noZensmooth && !isNativeSmoothScrollEnabledOn(document.body)) {
          var isHistorySupported = "history" in window && "pushState" in history;
          var isScrollRestorationSupported = isHistorySupported && "scrollRestoration" in history;
          if (isScrollRestorationSupported) {
            history.scrollRestoration = "auto";
          }
          window.addEventListener("load", function() {
            if (isScrollRestorationSupported) {
              setTimeout(function() {
                history.scrollRestoration = "manual";
              }, 9);
              window.addEventListener("popstate", function(event) {
                if (event.state && "zenscrollY" in event.state) {
                  zenscroll2.toY(event.state.zenscrollY);
                }
              }, false);
            }
            if (window.location.hash) {
              setTimeout(function() {
                var edgeOffset = zenscroll2.setup().edgeOffset;
                if (edgeOffset) {
                  var targetElem = document.getElementById(window.location.href.split("#")[1]);
                  if (targetElem) {
                    var targetY = Math.max(0, zenscroll2.getTopOf(targetElem) - edgeOffset);
                    var diff = zenscroll2.getY() - targetY;
                    if (0 <= diff && diff < 9) {
                      window.scrollTo(0, targetY);
                    }
                  }
                }
              }, 9);
            }
          }, false);
          var RE_noZensmooth = new RegExp("(^|\\s)noZensmooth(\\s|$)");
          window.addEventListener("click", function(event) {
            var anchor = event.target;
            while (anchor && anchor.tagName !== "A") {
              anchor = anchor.parentNode;
            }
            if (!anchor || event.which !== 1 || event.shiftKey || event.metaKey || event.ctrlKey || event.altKey) {
              return;
            }
            if (isScrollRestorationSupported) {
              var historyState = history.state && typeof history.state === "object" ? history.state : {};
              historyState.zenscrollY = zenscroll2.getY();
              try {
                history.replaceState(historyState, "");
              } catch (e) {
              }
            }
            var href = anchor.getAttribute("href") || "";
            if (href.indexOf("#") === 0 && !RE_noZensmooth.test(anchor.className)) {
              var targetY = 0;
              var targetElem = document.getElementById(href.substring(1));
              if (href !== "#") {
                if (!targetElem) {
                  return;
                }
                targetY = zenscroll2.getTopOf(targetElem);
              }
              event.preventDefault();
              var onDone = function() {
                window.location = href;
              };
              var edgeOffset = zenscroll2.setup().edgeOffset;
              if (edgeOffset) {
                targetY = Math.max(0, targetY - edgeOffset);
                if (isHistorySupported) {
                  onDone = function() {
                    history.pushState({}, "", href);
                  };
                }
              }
              zenscroll2.toY(targetY, null, onDone);
            }
          }, false);
        }
        return zenscroll2;
      });
    }
  });

  // app/scripts/common/function/debounceTime.js
  function debounceTime(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  // app/scripts/common/function/resizeObserver.js
  function resizeObserver(selector, callback, debounceTimeout = 300) {
    const { debounceTime: debounceTime2 } = theme;
    let lastWidth = selector.clientWidth;
    const debounce = debounceTime2((e) => {
      let newestWidth = selector.clientWidth;
      if (newestWidth == lastWidth)
        return;
      callback.apply(selector);
      lastWidth = newestWidth;
    }, debounceTimeout);
    if ("ResizeObserver" in window) {
      const resizeObserver2 = new ResizeObserver((entries) => {
        debounce.call(selector);
      });
      resizeObserver2.observe(selector);
    } else {
      window.addEventListener("resize", () => debounce.bind(selector));
    }
  }

  // app/scripts/common/function/inViewPort.js
  function inViewPort(el, callback, once = null) {
    const observer = new IntersectionObserver((entries) => {
      const isIntersecting = [...entries].some((i) => i.isIntersecting == true);
      callback(isIntersecting, entries);
      if (isIntersecting && once) {
        observer.disconnect();
      }
    });
    observer.observe(el);
  }

  // app/scripts/common/index.js
  window.theme = Object.assign(window.theme, {
    debounceTime,
    resizeObserver,
    inViewPort
  });

  // node_modules/@googlemaps/markerclusterer/dist/index.esm.js
  var import_fast_deep_equal = __toESM(require_fast_deep_equal());

  // node_modules/kdbush/index.js
  var ARRAY_TYPES = [
    Int8Array,
    Uint8Array,
    Uint8ClampedArray,
    Int16Array,
    Uint16Array,
    Int32Array,
    Uint32Array,
    Float32Array,
    Float64Array
  ];
  var VERSION = 1;
  var HEADER_SIZE = 8;
  var KDBush = class _KDBush {
    /**
     * Creates an index from raw `ArrayBuffer` data.
     * @param {ArrayBuffer} data
     */
    static from(data) {
      if (!(data instanceof ArrayBuffer)) {
        throw new Error("Data must be an instance of ArrayBuffer.");
      }
      const [magic, versionAndType] = new Uint8Array(data, 0, 2);
      if (magic !== 219) {
        throw new Error("Data does not appear to be in a KDBush format.");
      }
      const version = versionAndType >> 4;
      if (version !== VERSION) {
        throw new Error(`Got v${version} data when expected v${VERSION}.`);
      }
      const ArrayType = ARRAY_TYPES[versionAndType & 15];
      if (!ArrayType) {
        throw new Error("Unrecognized array type.");
      }
      const [nodeSize] = new Uint16Array(data, 2, 1);
      const [numItems] = new Uint32Array(data, 4, 1);
      return new _KDBush(numItems, nodeSize, ArrayType, data);
    }
    /**
     * Creates an index that will hold a given number of items.
     * @param {number} numItems
     * @param {number} [nodeSize=64] Size of the KD-tree node (64 by default).
     * @param {TypedArrayConstructor} [ArrayType=Float64Array] The array type used for coordinates storage (`Float64Array` by default).
     * @param {ArrayBuffer} [data] (For internal use only)
     */
    constructor(numItems, nodeSize = 64, ArrayType = Float64Array, data) {
      if (isNaN(numItems) || numItems < 0)
        throw new Error(`Unpexpected numItems value: ${numItems}.`);
      this.numItems = +numItems;
      this.nodeSize = Math.min(Math.max(+nodeSize, 2), 65535);
      this.ArrayType = ArrayType;
      this.IndexArrayType = numItems < 65536 ? Uint16Array : Uint32Array;
      const arrayTypeIndex = ARRAY_TYPES.indexOf(this.ArrayType);
      const coordsByteSize = numItems * 2 * this.ArrayType.BYTES_PER_ELEMENT;
      const idsByteSize = numItems * this.IndexArrayType.BYTES_PER_ELEMENT;
      const padCoords = (8 - idsByteSize % 8) % 8;
      if (arrayTypeIndex < 0) {
        throw new Error(`Unexpected typed array class: ${ArrayType}.`);
      }
      if (data && data instanceof ArrayBuffer) {
        this.data = data;
        this.ids = new this.IndexArrayType(this.data, HEADER_SIZE, numItems);
        this.coords = new this.ArrayType(this.data, HEADER_SIZE + idsByteSize + padCoords, numItems * 2);
        this._pos = numItems * 2;
        this._finished = true;
      } else {
        this.data = new ArrayBuffer(HEADER_SIZE + coordsByteSize + idsByteSize + padCoords);
        this.ids = new this.IndexArrayType(this.data, HEADER_SIZE, numItems);
        this.coords = new this.ArrayType(this.data, HEADER_SIZE + idsByteSize + padCoords, numItems * 2);
        this._pos = 0;
        this._finished = false;
        new Uint8Array(this.data, 0, 2).set([219, (VERSION << 4) + arrayTypeIndex]);
        new Uint16Array(this.data, 2, 1)[0] = nodeSize;
        new Uint32Array(this.data, 4, 1)[0] = numItems;
      }
    }
    /**
     * Add a point to the index.
     * @param {number} x
     * @param {number} y
     * @returns {number} An incremental index associated with the added item (starting from `0`).
     */
    add(x, y) {
      const index = this._pos >> 1;
      this.ids[index] = index;
      this.coords[this._pos++] = x;
      this.coords[this._pos++] = y;
      return index;
    }
    /**
     * Perform indexing of the added points.
     */
    finish() {
      const numAdded = this._pos >> 1;
      if (numAdded !== this.numItems) {
        throw new Error(`Added ${numAdded} items when expected ${this.numItems}.`);
      }
      sort(this.ids, this.coords, this.nodeSize, 0, this.numItems - 1, 0);
      this._finished = true;
      return this;
    }
    /**
     * Search the index for items within a given bounding box.
     * @param {number} minX
     * @param {number} minY
     * @param {number} maxX
     * @param {number} maxY
     * @returns {number[]} An array of indices correponding to the found items.
     */
    range(minX, minY, maxX, maxY) {
      if (!this._finished)
        throw new Error("Data not yet indexed - call index.finish().");
      const { ids, coords, nodeSize } = this;
      const stack = [0, ids.length - 1, 0];
      const result = [];
      while (stack.length) {
        const axis = stack.pop() || 0;
        const right = stack.pop() || 0;
        const left = stack.pop() || 0;
        if (right - left <= nodeSize) {
          for (let i = left; i <= right; i++) {
            const x2 = coords[2 * i];
            const y2 = coords[2 * i + 1];
            if (x2 >= minX && x2 <= maxX && y2 >= minY && y2 <= maxY)
              result.push(ids[i]);
          }
          continue;
        }
        const m = left + right >> 1;
        const x = coords[2 * m];
        const y = coords[2 * m + 1];
        if (x >= minX && x <= maxX && y >= minY && y <= maxY)
          result.push(ids[m]);
        if (axis === 0 ? minX <= x : minY <= y) {
          stack.push(left);
          stack.push(m - 1);
          stack.push(1 - axis);
        }
        if (axis === 0 ? maxX >= x : maxY >= y) {
          stack.push(m + 1);
          stack.push(right);
          stack.push(1 - axis);
        }
      }
      return result;
    }
    /**
     * Search the index for items within a given radius.
     * @param {number} qx
     * @param {number} qy
     * @param {number} r Query radius.
     * @returns {number[]} An array of indices correponding to the found items.
     */
    within(qx, qy, r) {
      if (!this._finished)
        throw new Error("Data not yet indexed - call index.finish().");
      const { ids, coords, nodeSize } = this;
      const stack = [0, ids.length - 1, 0];
      const result = [];
      const r2 = r * r;
      while (stack.length) {
        const axis = stack.pop() || 0;
        const right = stack.pop() || 0;
        const left = stack.pop() || 0;
        if (right - left <= nodeSize) {
          for (let i = left; i <= right; i++) {
            if (sqDist(coords[2 * i], coords[2 * i + 1], qx, qy) <= r2)
              result.push(ids[i]);
          }
          continue;
        }
        const m = left + right >> 1;
        const x = coords[2 * m];
        const y = coords[2 * m + 1];
        if (sqDist(x, y, qx, qy) <= r2)
          result.push(ids[m]);
        if (axis === 0 ? qx - r <= x : qy - r <= y) {
          stack.push(left);
          stack.push(m - 1);
          stack.push(1 - axis);
        }
        if (axis === 0 ? qx + r >= x : qy + r >= y) {
          stack.push(m + 1);
          stack.push(right);
          stack.push(1 - axis);
        }
      }
      return result;
    }
  };
  function sort(ids, coords, nodeSize, left, right, axis) {
    if (right - left <= nodeSize)
      return;
    const m = left + right >> 1;
    select(ids, coords, m, left, right, axis);
    sort(ids, coords, nodeSize, left, m - 1, 1 - axis);
    sort(ids, coords, nodeSize, m + 1, right, 1 - axis);
  }
  function select(ids, coords, k, left, right, axis) {
    while (right > left) {
      if (right - left > 600) {
        const n = right - left + 1;
        const m = k - left + 1;
        const z = Math.log(n);
        const s = 0.5 * Math.exp(2 * z / 3);
        const sd = 0.5 * Math.sqrt(z * s * (n - s) / n) * (m - n / 2 < 0 ? -1 : 1);
        const newLeft = Math.max(left, Math.floor(k - m * s / n + sd));
        const newRight = Math.min(right, Math.floor(k + (n - m) * s / n + sd));
        select(ids, coords, k, newLeft, newRight, axis);
      }
      const t = coords[2 * k + axis];
      let i = left;
      let j = right;
      swapItem(ids, coords, left, k);
      if (coords[2 * right + axis] > t)
        swapItem(ids, coords, left, right);
      while (i < j) {
        swapItem(ids, coords, i, j);
        i++;
        j--;
        while (coords[2 * i + axis] < t)
          i++;
        while (coords[2 * j + axis] > t)
          j--;
      }
      if (coords[2 * left + axis] === t)
        swapItem(ids, coords, left, j);
      else {
        j++;
        swapItem(ids, coords, j, right);
      }
      if (j <= k)
        left = j + 1;
      if (k <= j)
        right = j - 1;
    }
  }
  function swapItem(ids, coords, i, j) {
    swap(ids, i, j);
    swap(coords, 2 * i, 2 * j);
    swap(coords, 2 * i + 1, 2 * j + 1);
  }
  function swap(arr, i, j) {
    const tmp = arr[i];
    arr[i] = arr[j];
    arr[j] = tmp;
  }
  function sqDist(ax, ay, bx, by) {
    const dx = ax - bx;
    const dy = ay - by;
    return dx * dx + dy * dy;
  }

  // node_modules/supercluster/index.js
  var defaultOptions = {
    minZoom: 0,
    // min zoom to generate clusters on
    maxZoom: 16,
    // max zoom level to cluster the points on
    minPoints: 2,
    // minimum points to form a cluster
    radius: 40,
    // cluster radius in pixels
    extent: 512,
    // tile extent (radius is calculated relative to it)
    nodeSize: 64,
    // size of the KD-tree leaf node, affects performance
    log: false,
    // whether to log timing info
    // whether to generate numeric ids for input features (in vector tiles)
    generateId: false,
    // a reduce function for calculating custom cluster properties
    reduce: null,
    // (accumulated, props) => { accumulated.sum += props.sum; }
    // properties to use for individual points when running the reducer
    map: (props) => props
    // props => ({sum: props.my_value})
  };
  var fround = Math.fround || /* @__PURE__ */ ((tmp) => (x) => {
    tmp[0] = +x;
    return tmp[0];
  })(new Float32Array(1));
  var OFFSET_ZOOM = 2;
  var OFFSET_ID = 3;
  var OFFSET_PARENT = 4;
  var OFFSET_NUM = 5;
  var OFFSET_PROP = 6;
  var Supercluster = class {
    constructor(options) {
      this.options = Object.assign(Object.create(defaultOptions), options);
      this.trees = new Array(this.options.maxZoom + 1);
      this.stride = this.options.reduce ? 7 : 6;
      this.clusterProps = [];
    }
    load(points) {
      const { log, minZoom, maxZoom } = this.options;
      if (log)
        console.time("total time");
      const timerId = `prepare ${points.length} points`;
      if (log)
        console.time(timerId);
      this.points = points;
      const data = [];
      for (let i = 0; i < points.length; i++) {
        const p = points[i];
        if (!p.geometry)
          continue;
        const [lng, lat] = p.geometry.coordinates;
        const x = fround(lngX(lng));
        const y = fround(latY(lat));
        data.push(
          x,
          y,
          // projected point coordinates
          Infinity,
          // the last zoom the point was processed at
          i,
          // index of the source feature in the original input array
          -1,
          // parent cluster id
          1
          // number of points in a cluster
        );
        if (this.options.reduce)
          data.push(0);
      }
      let tree = this.trees[maxZoom + 1] = this._createTree(data);
      if (log)
        console.timeEnd(timerId);
      for (let z = maxZoom; z >= minZoom; z--) {
        const now = +Date.now();
        tree = this.trees[z] = this._createTree(this._cluster(tree, z));
        if (log)
          console.log("z%d: %d clusters in %dms", z, tree.numItems, +Date.now() - now);
      }
      if (log)
        console.timeEnd("total time");
      return this;
    }
    getClusters(bbox, zoom) {
      let minLng = ((bbox[0] + 180) % 360 + 360) % 360 - 180;
      const minLat = Math.max(-90, Math.min(90, bbox[1]));
      let maxLng = bbox[2] === 180 ? 180 : ((bbox[2] + 180) % 360 + 360) % 360 - 180;
      const maxLat = Math.max(-90, Math.min(90, bbox[3]));
      if (bbox[2] - bbox[0] >= 360) {
        minLng = -180;
        maxLng = 180;
      } else if (minLng > maxLng) {
        const easternHem = this.getClusters([minLng, minLat, 180, maxLat], zoom);
        const westernHem = this.getClusters([-180, minLat, maxLng, maxLat], zoom);
        return easternHem.concat(westernHem);
      }
      const tree = this.trees[this._limitZoom(zoom)];
      const ids = tree.range(lngX(minLng), latY(maxLat), lngX(maxLng), latY(minLat));
      const data = tree.data;
      const clusters = [];
      for (const id of ids) {
        const k = this.stride * id;
        clusters.push(data[k + OFFSET_NUM] > 1 ? getClusterJSON(data, k, this.clusterProps) : this.points[data[k + OFFSET_ID]]);
      }
      return clusters;
    }
    getChildren(clusterId) {
      const originId = this._getOriginId(clusterId);
      const originZoom = this._getOriginZoom(clusterId);
      const errorMsg = "No cluster with the specified id.";
      const tree = this.trees[originZoom];
      if (!tree)
        throw new Error(errorMsg);
      const data = tree.data;
      if (originId * this.stride >= data.length)
        throw new Error(errorMsg);
      const r = this.options.radius / (this.options.extent * Math.pow(2, originZoom - 1));
      const x = data[originId * this.stride];
      const y = data[originId * this.stride + 1];
      const ids = tree.within(x, y, r);
      const children = [];
      for (const id of ids) {
        const k = id * this.stride;
        if (data[k + OFFSET_PARENT] === clusterId) {
          children.push(data[k + OFFSET_NUM] > 1 ? getClusterJSON(data, k, this.clusterProps) : this.points[data[k + OFFSET_ID]]);
        }
      }
      if (children.length === 0)
        throw new Error(errorMsg);
      return children;
    }
    getLeaves(clusterId, limit, offset) {
      limit = limit || 10;
      offset = offset || 0;
      const leaves = [];
      this._appendLeaves(leaves, clusterId, limit, offset, 0);
      return leaves;
    }
    getTile(z, x, y) {
      const tree = this.trees[this._limitZoom(z)];
      const z2 = Math.pow(2, z);
      const { extent, radius } = this.options;
      const p = radius / extent;
      const top = (y - p) / z2;
      const bottom = (y + 1 + p) / z2;
      const tile = {
        features: []
      };
      this._addTileFeatures(
        tree.range((x - p) / z2, top, (x + 1 + p) / z2, bottom),
        tree.data,
        x,
        y,
        z2,
        tile
      );
      if (x === 0) {
        this._addTileFeatures(
          tree.range(1 - p / z2, top, 1, bottom),
          tree.data,
          z2,
          y,
          z2,
          tile
        );
      }
      if (x === z2 - 1) {
        this._addTileFeatures(
          tree.range(0, top, p / z2, bottom),
          tree.data,
          -1,
          y,
          z2,
          tile
        );
      }
      return tile.features.length ? tile : null;
    }
    getClusterExpansionZoom(clusterId) {
      let expansionZoom = this._getOriginZoom(clusterId) - 1;
      while (expansionZoom <= this.options.maxZoom) {
        const children = this.getChildren(clusterId);
        expansionZoom++;
        if (children.length !== 1)
          break;
        clusterId = children[0].properties.cluster_id;
      }
      return expansionZoom;
    }
    _appendLeaves(result, clusterId, limit, offset, skipped) {
      const children = this.getChildren(clusterId);
      for (const child of children) {
        const props = child.properties;
        if (props && props.cluster) {
          if (skipped + props.point_count <= offset) {
            skipped += props.point_count;
          } else {
            skipped = this._appendLeaves(result, props.cluster_id, limit, offset, skipped);
          }
        } else if (skipped < offset) {
          skipped++;
        } else {
          result.push(child);
        }
        if (result.length === limit)
          break;
      }
      return skipped;
    }
    _createTree(data) {
      const tree = new KDBush(data.length / this.stride | 0, this.options.nodeSize, Float32Array);
      for (let i = 0; i < data.length; i += this.stride)
        tree.add(data[i], data[i + 1]);
      tree.finish();
      tree.data = data;
      return tree;
    }
    _addTileFeatures(ids, data, x, y, z2, tile) {
      for (const i of ids) {
        const k = i * this.stride;
        const isCluster = data[k + OFFSET_NUM] > 1;
        let tags, px, py;
        if (isCluster) {
          tags = getClusterProperties(data, k, this.clusterProps);
          px = data[k];
          py = data[k + 1];
        } else {
          const p = this.points[data[k + OFFSET_ID]];
          tags = p.properties;
          const [lng, lat] = p.geometry.coordinates;
          px = lngX(lng);
          py = latY(lat);
        }
        const f = {
          type: 1,
          geometry: [[
            Math.round(this.options.extent * (px * z2 - x)),
            Math.round(this.options.extent * (py * z2 - y))
          ]],
          tags
        };
        let id;
        if (isCluster || this.options.generateId) {
          id = data[k + OFFSET_ID];
        } else {
          id = this.points[data[k + OFFSET_ID]].id;
        }
        if (id !== void 0)
          f.id = id;
        tile.features.push(f);
      }
    }
    _limitZoom(z) {
      return Math.max(this.options.minZoom, Math.min(Math.floor(+z), this.options.maxZoom + 1));
    }
    _cluster(tree, zoom) {
      const { radius, extent, reduce, minPoints } = this.options;
      const r = radius / (extent * Math.pow(2, zoom));
      const data = tree.data;
      const nextData = [];
      const stride = this.stride;
      for (let i = 0; i < data.length; i += stride) {
        if (data[i + OFFSET_ZOOM] <= zoom)
          continue;
        data[i + OFFSET_ZOOM] = zoom;
        const x = data[i];
        const y = data[i + 1];
        const neighborIds = tree.within(data[i], data[i + 1], r);
        const numPointsOrigin = data[i + OFFSET_NUM];
        let numPoints = numPointsOrigin;
        for (const neighborId of neighborIds) {
          const k = neighborId * stride;
          if (data[k + OFFSET_ZOOM] > zoom)
            numPoints += data[k + OFFSET_NUM];
        }
        if (numPoints > numPointsOrigin && numPoints >= minPoints) {
          let wx = x * numPointsOrigin;
          let wy = y * numPointsOrigin;
          let clusterProperties;
          let clusterPropIndex = -1;
          const id = ((i / stride | 0) << 5) + (zoom + 1) + this.points.length;
          for (const neighborId of neighborIds) {
            const k = neighborId * stride;
            if (data[k + OFFSET_ZOOM] <= zoom)
              continue;
            data[k + OFFSET_ZOOM] = zoom;
            const numPoints2 = data[k + OFFSET_NUM];
            wx += data[k] * numPoints2;
            wy += data[k + 1] * numPoints2;
            data[k + OFFSET_PARENT] = id;
            if (reduce) {
              if (!clusterProperties) {
                clusterProperties = this._map(data, i, true);
                clusterPropIndex = this.clusterProps.length;
                this.clusterProps.push(clusterProperties);
              }
              reduce(clusterProperties, this._map(data, k));
            }
          }
          data[i + OFFSET_PARENT] = id;
          nextData.push(wx / numPoints, wy / numPoints, Infinity, id, -1, numPoints);
          if (reduce)
            nextData.push(clusterPropIndex);
        } else {
          for (let j = 0; j < stride; j++)
            nextData.push(data[i + j]);
          if (numPoints > 1) {
            for (const neighborId of neighborIds) {
              const k = neighborId * stride;
              if (data[k + OFFSET_ZOOM] <= zoom)
                continue;
              data[k + OFFSET_ZOOM] = zoom;
              for (let j = 0; j < stride; j++)
                nextData.push(data[k + j]);
            }
          }
        }
      }
      return nextData;
    }
    // get index of the point from which the cluster originated
    _getOriginId(clusterId) {
      return clusterId - this.points.length >> 5;
    }
    // get zoom of the point from which the cluster originated
    _getOriginZoom(clusterId) {
      return (clusterId - this.points.length) % 32;
    }
    _map(data, i, clone) {
      if (data[i + OFFSET_NUM] > 1) {
        const props = this.clusterProps[data[i + OFFSET_PROP]];
        return clone ? Object.assign({}, props) : props;
      }
      const original = this.points[data[i + OFFSET_ID]].properties;
      const result = this.options.map(original);
      return clone && result === original ? Object.assign({}, result) : result;
    }
  };
  function getClusterJSON(data, i, clusterProps) {
    return {
      type: "Feature",
      id: data[i + OFFSET_ID],
      properties: getClusterProperties(data, i, clusterProps),
      geometry: {
        type: "Point",
        coordinates: [xLng(data[i]), yLat(data[i + 1])]
      }
    };
  }
  function getClusterProperties(data, i, clusterProps) {
    const count = data[i + OFFSET_NUM];
    const abbrev = count >= 1e4 ? `${Math.round(count / 1e3)}k` : count >= 1e3 ? `${Math.round(count / 100) / 10}k` : count;
    const propIndex = data[i + OFFSET_PROP];
    const properties = propIndex === -1 ? {} : Object.assign({}, clusterProps[propIndex]);
    return Object.assign(properties, {
      cluster: true,
      cluster_id: data[i + OFFSET_ID],
      point_count: count,
      point_count_abbreviated: abbrev
    });
  }
  function lngX(lng) {
    return lng / 360 + 0.5;
  }
  function latY(lat) {
    const sin = Math.sin(lat * Math.PI / 180);
    const y = 0.5 - 0.25 * Math.log((1 + sin) / (1 - sin)) / Math.PI;
    return y < 0 ? 0 : y > 1 ? 1 : y;
  }
  function xLng(x) {
    return (x - 0.5) * 360;
  }
  function yLat(y) {
    const y2 = (180 - y * 360) * Math.PI / 180;
    return 360 * Math.atan(Math.exp(y2)) / Math.PI - 90;
  }

  // node_modules/@googlemaps/markerclusterer/dist/index.esm.js
  /*! *****************************************************************************
  Copyright (c) Microsoft Corporation.
  
  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.
  
  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** */
  function __rest(s, e) {
    var t = {};
    for (var p in s)
      if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
      for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
          t[p[i]] = s[p[i]];
      }
    return t;
  }
  var MarkerUtils = class {
    static isAdvancedMarkerAvailable(map) {
      return google.maps.marker && map.getMapCapabilities().isAdvancedMarkersAvailable === true;
    }
    static isAdvancedMarker(marker) {
      return google.maps.marker && marker instanceof google.maps.marker.AdvancedMarkerElement;
    }
    static setMap(marker, map) {
      if (this.isAdvancedMarker(marker)) {
        marker.map = map;
      } else {
        marker.setMap(map);
      }
    }
    static getPosition(marker) {
      if (this.isAdvancedMarker(marker)) {
        if (marker.position) {
          if (marker.position instanceof google.maps.LatLng) {
            return marker.position;
          }
          if (marker.position.lat && marker.position.lng) {
            return new google.maps.LatLng(marker.position.lat, marker.position.lng);
          }
        }
        return new google.maps.LatLng(null);
      }
      return marker.getPosition();
    }
    static getVisible(marker) {
      if (this.isAdvancedMarker(marker)) {
        return true;
      }
      return marker.getVisible();
    }
  };
  var Cluster = class {
    constructor({ markers, position }) {
      this.markers = markers;
      if (position) {
        if (position instanceof google.maps.LatLng) {
          this._position = position;
        } else {
          this._position = new google.maps.LatLng(position);
        }
      }
    }
    get bounds() {
      if (this.markers.length === 0 && !this._position) {
        return;
      }
      const bounds = new google.maps.LatLngBounds(this._position, this._position);
      for (const marker of this.markers) {
        bounds.extend(MarkerUtils.getPosition(marker));
      }
      return bounds;
    }
    get position() {
      return this._position || this.bounds.getCenter();
    }
    /**
     * Get the count of **visible** markers.
     */
    get count() {
      return this.markers.filter((m) => MarkerUtils.getVisible(m)).length;
    }
    /**
     * Add a marker to the cluster.
     */
    push(marker) {
      this.markers.push(marker);
    }
    /**
     * Cleanup references and remove marker from map.
     */
    delete() {
      if (this.marker) {
        MarkerUtils.setMap(this.marker, null);
        this.marker = void 0;
      }
      this.markers.length = 0;
    }
  };
  var AbstractAlgorithm = class {
    constructor({ maxZoom = 16 }) {
      this.maxZoom = maxZoom;
    }
    /**
     * Helper function to bypass clustering based upon some map state such as
     * zoom, number of markers, etc.
     *
     * ```typescript
     *  cluster({markers, map}: AlgorithmInput): Cluster[] {
     *    if (shouldBypassClustering(map)) {
     *      return this.noop({markers})
     *    }
     * }
     * ```
     */
    noop({ markers }) {
      return noop(markers);
    }
  };
  var noop = (markers) => {
    const clusters = markers.map((marker) => new Cluster({
      position: MarkerUtils.getPosition(marker),
      markers: [marker]
    }));
    return clusters;
  };
  var SuperClusterAlgorithm = class extends AbstractAlgorithm {
    constructor(_a) {
      var { maxZoom, radius = 60 } = _a, options = __rest(_a, ["maxZoom", "radius"]);
      super({ maxZoom });
      this.state = { zoom: -1 };
      this.superCluster = new Supercluster(Object.assign({ maxZoom: this.maxZoom, radius }, options));
    }
    calculate(input) {
      let changed = false;
      const state = { zoom: input.map.getZoom() };
      if (!(0, import_fast_deep_equal.default)(input.markers, this.markers)) {
        changed = true;
        this.markers = [...input.markers];
        const points = this.markers.map((marker) => {
          const position = MarkerUtils.getPosition(marker);
          const coordinates = [position.lng(), position.lat()];
          return {
            type: "Feature",
            geometry: {
              type: "Point",
              coordinates
            },
            properties: { marker }
          };
        });
        this.superCluster.load(points);
      }
      if (!changed) {
        if (this.state.zoom <= this.maxZoom || state.zoom <= this.maxZoom) {
          changed = !(0, import_fast_deep_equal.default)(this.state, state);
        }
      }
      this.state = state;
      if (changed) {
        this.clusters = this.cluster(input);
      }
      return { clusters: this.clusters, changed };
    }
    cluster({ map }) {
      return this.superCluster.getClusters([-180, -90, 180, 90], Math.round(map.getZoom())).map((feature) => this.transformCluster(feature));
    }
    transformCluster({ geometry: { coordinates: [lng, lat] }, properties }) {
      if (properties.cluster) {
        return new Cluster({
          markers: this.superCluster.getLeaves(properties.cluster_id, Infinity).map((leaf) => leaf.properties.marker),
          position: { lat, lng }
        });
      }
      const marker = properties.marker;
      return new Cluster({
        markers: [marker],
        position: MarkerUtils.getPosition(marker)
      });
    }
  };
  var ClusterStats = class {
    constructor(markers, clusters) {
      this.markers = { sum: markers.length };
      const clusterMarkerCounts = clusters.map((a) => a.count);
      const clusterMarkerSum = clusterMarkerCounts.reduce((a, b) => a + b, 0);
      this.clusters = {
        count: clusters.length,
        markers: {
          mean: clusterMarkerSum / clusters.length,
          sum: clusterMarkerSum,
          min: Math.min(...clusterMarkerCounts),
          max: Math.max(...clusterMarkerCounts)
        }
      };
    }
  };
  var DefaultRenderer = class {
    /**
     * The default render function for the library used by {@link MarkerClusterer}.
     *
     * Currently set to use the following:
     *
     * ```typescript
     * // change color if this cluster has more markers than the mean cluster
     * const color =
     *   count > Math.max(10, stats.clusters.markers.mean)
     *     ? "#ff0000"
     *     : "#0000ff";
     *
     * // create svg url with fill color
     * const svg = window.btoa(`
     * <svg fill="${color}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">
     *   <circle cx="120" cy="120" opacity=".6" r="70" />
     *   <circle cx="120" cy="120" opacity=".3" r="90" />
     *   <circle cx="120" cy="120" opacity=".2" r="110" />
     *   <circle cx="120" cy="120" opacity=".1" r="130" />
     * </svg>`);
     *
     * // create marker using svg icon
     * return new google.maps.Marker({
     *   position,
     *   icon: {
     *     url: `data:image/svg+xml;base64,${svg}`,
     *     scaledSize: new google.maps.Size(45, 45),
     *   },
     *   label: {
     *     text: String(count),
     *     color: "rgba(255,255,255,0.9)",
     *     fontSize: "12px",
     *   },
     *   // adjust zIndex to be above other markers
     *   zIndex: 1000 + count,
     * });
     * ```
     */
    render({ count, position }, stats, map) {
      const color = count > Math.max(10, stats.clusters.markers.mean) ? "#ff0000" : "#0000ff";
      const svg = `<svg fill="${color}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240" width="50" height="50">
<circle cx="120" cy="120" opacity=".6" r="70" />
<circle cx="120" cy="120" opacity=".3" r="90" />
<circle cx="120" cy="120" opacity=".2" r="110" />
<text x="50%" y="50%" style="fill:#fff" text-anchor="middle" font-size="50" dominant-baseline="middle" font-family="roboto,arial,sans-serif">${count}</text>
</svg>`;
      const title = `Cluster of ${count} markers`, zIndex = Number(google.maps.Marker.MAX_ZINDEX) + count;
      if (MarkerUtils.isAdvancedMarkerAvailable(map)) {
        const parser = new DOMParser();
        const svgEl = parser.parseFromString(svg, "image/svg+xml").documentElement;
        svgEl.setAttribute("transform", "translate(0 25)");
        const clusterOptions2 = {
          map,
          position,
          zIndex,
          title,
          content: svgEl
        };
        return new google.maps.marker.AdvancedMarkerElement(clusterOptions2);
      }
      const clusterOptions = {
        position,
        zIndex,
        title,
        icon: {
          url: `data:image/svg+xml;base64,${btoa(svg)}`,
          anchor: new google.maps.Point(25, 25)
        }
      };
      return new google.maps.Marker(clusterOptions);
    }
  };
  function extend(type1, type2) {
    for (let property in type2.prototype) {
      type1.prototype[property] = type2.prototype[property];
    }
  }
  var OverlayViewSafe = class _OverlayViewSafe {
    constructor() {
      extend(_OverlayViewSafe, google.maps.OverlayView);
    }
  };
  var MarkerClustererEvents;
  (function(MarkerClustererEvents2) {
    MarkerClustererEvents2["CLUSTERING_BEGIN"] = "clusteringbegin";
    MarkerClustererEvents2["CLUSTERING_END"] = "clusteringend";
    MarkerClustererEvents2["CLUSTER_CLICK"] = "click";
  })(MarkerClustererEvents || (MarkerClustererEvents = {}));
  var defaultOnClusterClickHandler = (_, cluster, map) => {
    map.fitBounds(cluster.bounds);
  };
  var MarkerClusterer = class extends OverlayViewSafe {
    constructor({ map, markers = [], algorithmOptions = {}, algorithm = new SuperClusterAlgorithm(algorithmOptions), renderer = new DefaultRenderer(), onClusterClick = defaultOnClusterClickHandler }) {
      super();
      this.markers = [...markers];
      this.clusters = [];
      this.algorithm = algorithm;
      this.renderer = renderer;
      this.onClusterClick = onClusterClick;
      if (map) {
        this.setMap(map);
      }
    }
    addMarker(marker, noDraw) {
      if (this.markers.includes(marker)) {
        return;
      }
      this.markers.push(marker);
      if (!noDraw) {
        this.render();
      }
    }
    addMarkers(markers, noDraw) {
      markers.forEach((marker) => {
        this.addMarker(marker, true);
      });
      if (!noDraw) {
        this.render();
      }
    }
    removeMarker(marker, noDraw) {
      const index = this.markers.indexOf(marker);
      if (index === -1) {
        return false;
      }
      MarkerUtils.setMap(marker, null);
      this.markers.splice(index, 1);
      if (!noDraw) {
        this.render();
      }
      return true;
    }
    removeMarkers(markers, noDraw) {
      let removed = false;
      markers.forEach((marker) => {
        removed = this.removeMarker(marker, true) || removed;
      });
      if (removed && !noDraw) {
        this.render();
      }
      return removed;
    }
    clearMarkers(noDraw) {
      this.markers.length = 0;
      if (!noDraw) {
        this.render();
      }
    }
    /**
     * Recalculates and draws all the marker clusters.
     */
    render() {
      const map = this.getMap();
      if (map instanceof google.maps.Map && map.getProjection()) {
        google.maps.event.trigger(this, MarkerClustererEvents.CLUSTERING_BEGIN, this);
        const { clusters, changed } = this.algorithm.calculate({
          markers: this.markers,
          map,
          mapCanvasProjection: this.getProjection()
        });
        if (changed || changed == void 0) {
          const singleMarker = /* @__PURE__ */ new Set();
          for (const cluster of clusters) {
            if (cluster.markers.length == 1) {
              singleMarker.add(cluster.markers[0]);
            }
          }
          const groupMarkers = [];
          for (const cluster of this.clusters) {
            if (cluster.marker == null) {
              continue;
            }
            if (cluster.markers.length == 1) {
              if (!singleMarker.has(cluster.marker)) {
                MarkerUtils.setMap(cluster.marker, null);
              }
            } else {
              groupMarkers.push(cluster.marker);
            }
          }
          this.clusters = clusters;
          this.renderClusters();
          requestAnimationFrame(() => groupMarkers.forEach((marker) => MarkerUtils.setMap(marker, null)));
        }
        google.maps.event.trigger(this, MarkerClustererEvents.CLUSTERING_END, this);
      }
    }
    onAdd() {
      this.idleListener = this.getMap().addListener("idle", this.render.bind(this));
      this.render();
    }
    onRemove() {
      google.maps.event.removeListener(this.idleListener);
      this.reset();
    }
    reset() {
      this.markers.forEach((marker) => MarkerUtils.setMap(marker, null));
      this.clusters.forEach((cluster) => cluster.delete());
      this.clusters = [];
    }
    renderClusters() {
      const stats = new ClusterStats(this.markers, this.clusters);
      const map = this.getMap();
      this.clusters.forEach((cluster) => {
        if (cluster.markers.length === 1) {
          cluster.marker = cluster.markers[0];
        } else {
          cluster.marker = this.renderer.render(cluster, stats, map);
          cluster.markers.forEach((marker) => MarkerUtils.setMap(marker, null));
          if (this.onClusterClick) {
            cluster.marker.addListener(
              "click",
              /* istanbul ignore next */
              (event) => {
                google.maps.event.trigger(this, MarkerClustererEvents.CLUSTER_CLICK, cluster);
                this.onClusterClick(event, cluster, map);
              }
            );
          }
        }
        MarkerUtils.setMap(cluster.marker, map);
      });
    }
  };

  // app/scripts/common/component/MapComponent.js
  !customElements.get("map-component") && customElements.define(
    "map-component",
    class extends HTMLElement {
      constructor() {
        super();
        window.initMap = this.initMap();
      }
      async initMap() {
        this.config = JSON.parse(
          this.querySelector('script[type="application/json"]').textContent
        );
        const { Map } = await google.maps.importLibrary("maps");
        const { Autocomplete } = await google.maps.importLibrary("places");
        const { AdvancedMarkerElement } = await google.maps.importLibrary(
          "marker"
        );
        this.AdvancedMarkerElement = AdvancedMarkerElement;
        this.infoWindow = new google.maps.InfoWindow();
        if (this.currentLocation) {
          const [lat2, lng2] = this.currentLocation;
          this.config.startPoint = [lat2, lng2];
        }
        const {
          zoom,
          startPoint: [lat, lng]
        } = this.config;
        this.map = new google.maps.Map(this.querySelector(".mapJS"), {
          center: { lat, lng },
          zoom,
          mapId: "DEMO_MAP_ID",
          zoomControl: true,
          zoomControlOptions: {
            position: google.maps.ControlPosition.RIGHT_BOTTOM
          }
        });
        window.addEventListener("map:loadMarker", (event) => {
          const {
            detail: { stores }
          } = event;
          if (this.markerClusterer) {
            this.markerClusterer.clearMarkers();
          }
          this.stores = stores;
          const markers = stores.map((store, i) => this.createMaker(store));
          this.markerClusterer = new MarkerClusterer({
            markers,
            map: this.map
          });
        });
        window.addEventListener("map:panTo", (event) => {
          const {
            detail: { latlng }
          } = event;
          this.map.panTo(latlng);
          this.map.setZoom(10);
        });
      }
      // set addStore(value) {
      //   const array = [...this.config.stores, ...value];
      //   const uniqueArray = Array.from(new Set(array.map(JSON.stringify))).map(JSON.parse);
      //   this.config.stores = uniqueArray;
      // }
      createMaker(store) {
        const { latitude: lat, longitude: lng, title, pin } = store;
        const { AdvancedMarkerElement, map, infoWindow } = this;
        const position = { lat: +lat, lng: +lng };
        if (typeof AdvancedMarkerElement == "undefined")
          return;
        const marker = new AdvancedMarkerElement({
          position,
          content: buildContent(pin)
        });
        marker.addListener("click", ({ domEvent, latLng }) => {
          openPopup();
          let classStore = `.jsStoreItem[data-lat="${lat}"][data-lng="${lng}"]`;
          if (window.matchMedia("(max-width: 768px)").matches) {
            classStore = ".jsLocationMobile " + classStore;
          }
          document.querySelectorAll(".jsStoreItem.selected")?.forEach((item) => item.classList.remove("selected"));
          document.querySelectorAll(".jsStoreDetail.active")?.forEach((item) => item.classList.remove("active"));
          document.querySelector(classStore)?.classList.add("selected");
          document.querySelector(classStore)?.closest("store-location").classList.add("show-store-selected");
        });
        store.goTo = () => {
          map.panTo(position);
          map.setZoom(14);
          openPopup();
        };
        const openPopup = () => {
          infoWindow.close();
          infoWindow.setContent(store.infoWindow);
          infoWindow.open(marker.map, marker);
        };
        function buildContent(icon) {
          const content = document.createElement("div");
          content.classList.add("property");
          content.innerHTML = `<div class="icon">${icon}</div>`;
          return content;
        }
        return marker;
      }
      setCenter(lat, lng) {
        const store = this.stores.find((i) => {
          return +i.latitude == +lat && +i.longitude == +lng;
        });
        store?.goTo();
      }
      async getSuggestions(query) {
        const resultsElement = document.getElementById("locationSuggest");
        if (query.length < 2) {
          resultsElement.innerHTML = "";
          return;
        }
        if (this.getSuggest)
          clearTimeout(this.getSuggest);
        this.getSuggest = setTimeout(async () => {
          try {
            const cacheKey = `autocomplete_${query}`;
            const cachedData = localStorage.getItem(cacheKey);
            const cacheTTL = 60 * 60 * 1e3;
            if (cachedData) {
              const { data: data2, timestamp } = JSON.parse(cachedData);
              if (Date.now() - timestamp < cacheTTL) {
                this.renderSuggestions(resultsElement, data2);
                return;
              }
            }
            const { Place, AutocompleteSessionToken, AutocompleteSuggestion } = await google.maps.importLibrary("places");
            const token = new AutocompleteSessionToken();
            const request = {
              input: query,
              sessionToken: token
            };
            const { suggestions } = await AutocompleteSuggestion.fetchAutocompleteSuggestions(
              request
            );
            const data = suggestions.map(
              ({ placePrediction }) => placePrediction.text.toString()
            );
            localStorage.setItem(
              cacheKey,
              JSON.stringify({
                data,
                timestamp: Date.now()
              })
            );
            this.renderSuggestions(resultsElement, data);
          } catch (error) {
            console.error("Error fetching suggestions:", error);
          } finally {
            this.getSuggest = null;
          }
        }, 0);
      }
      renderSuggestions(resultsElement, suggestions) {
        resultsElement.innerHTML = "";
        suggestions.forEach((text) => {
          const listItem = document.createElement("li");
          const a = document.createElement("a");
          a.href = "javascript:void(0);";
          a.textContent = text;
          a.className = "no-target";
          a.setAttribute("tabindex", "0");
          listItem.appendChild(a);
          resultsElement.appendChild(listItem);
        });
      }
    }
  );
  !window.customElements.get("location-search") && customElements.define(
    "location-search",
    class extends HTMLElement {
      connectedCallback() {
        this.wrapper = document.querySelectorAll(".jsStoreItemsWrapper");
        this.render(this.textContent.trim());
      }
      async render(url) {
        const f = await fetch(url);
        const result = await f.text();
        const parts = result.split("<!-- !!! -->");
        window.temptStoreItemList = (window.temptStoreItemList || "") + parts[2];
        window.storeMarker = (window.storeMarker || "") + parts[3];
        const loadMore = parts[1] || "";
        if (!loadMore.length) {
          this.wrapper.forEach((wrapper, index) => {
            wrapper.innerHTML += window.temptStoreItemList;
          });
          document.body.insertAdjacentHTML("beforeend", window.storeMarker);
          window.dispatchEvent(
            new CustomEvent("store:loaded", {
              detail: {
                stores: document.querySelector("map-component").config.stores
              }
            })
          );
        } else {
          this.insertAdjacentHTML("afterend", loadMore);
        }
        this.remove();
      }
    }
  );

  // app/scripts/common/function/scroll.js
  var import_zenscroll = __toESM(require_zenscroll(), 1);
  function Scroll(selector, duration, offset) {
    var duration = duration || 500;
    var offset = offset || 0;
    const headerSticky = document.querySelector(".cc-header--sticky")?.getBoundingClientRect().bottom || 0;
    headerSticky > 0 && (offset = offset - headerSticky);
    const top = selector.offsetTop + offset;
    import_zenscroll.default.toY(top, duration);
  }

  // app/scripts/common/component/StoreLocation.js
  !window.customElements.get("store-location") && customElements.define("store-location", class extends HTMLElement {
    constructor() {
      super();
      document.body.addEventListener("click", (e) => {
        const { target } = e;
        this.onFilterStore(target);
        this.onStoreClick(target);
        this.onSearchLocation(target);
        this.onScrollTarget(target);
        this.onSuggestClick(target);
        if (target.closest(".jsClose") || target.classList.contains("jsStoreDetail") && target.classList.contains("active")) {
          e.preventDefault();
          target.closest(".active")?.classList.remove("active");
          document.body.classList.remove("on_sm:overflow-hidden");
          document.querySelectorAll(".jsStoreItem.selected")?.forEach((item) => item.classList.remove("selected"));
          this.classList.remove("show-store-selected");
        }
      });
      const inputSearch = this.querySelector(".jsLocationSearchInput");
      document.addEventListener("keydown", (e) => {
        const activeElement = document.activeElement;
        const links = Array.from(this.querySelectorAll("#locationSuggest a"));
        if (!activeElement.classList.contains("jsLocationSearchInput") && !links.includes(activeElement))
          return;
        let currentIndex = links.indexOf(activeElement) || 0;
        switch (e.key) {
          case "Enter":
            e.preventDefault();
            if (activeElement.classList.contains("jsLocationSearchInput"))
              this.onSearchLocation(null, true);
            if (links.includes(activeElement)) {
              document.querySelector(".jsLocationSearchInput").value = activeElement.textContent;
              this.onSearchLocation(null, true);
            }
            break;
          case "Tab":
          case "ArrowDown":
            e.preventDefault();
            const nextIndex = (currentIndex + 1) % links.length;
            links[nextIndex].focus();
            break;
          case "ArrowUp":
            e.preventDefault();
            const prevIndex = (currentIndex - 1 + links.length) % links.length;
            links[prevIndex].focus();
            break;
        }
      });
      inputSearch.addEventListener("input", this.onSearchType.bind(this));
      this.mapEl = document.querySelector("map-component");
      this.config = this.mapEl.config;
      if ("geolocation" in navigator) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const latitude = position.coords.latitude;
            const longitude = position.coords.longitude;
            this.mapEl.currentLocation = [latitude, longitude];
            inputSearch.value = "Current location";
            this.onSearchLocation(null, true);
          },
          (error) => {
            switch (error.code) {
              case error.PERMISSION_DENIED:
                console.log("User denied the request for Geolocation.");
                break;
              case error.POSITION_UNAVAILABLE:
                console.log("Location information is unavailable.");
                break;
              case error.TIMEOUT:
                console.log("The request to get user location timed out.");
                break;
              default:
                console.log("An unknown error occurred.");
            }
          }
        );
      }
    }
    onFilterStore(el) {
      if (!el.closest(".jsLocationFilter"))
        return;
      const currentFilter = el.closest(".jsLocationFilter");
      const value = currentFilter.dataset.filterValue;
      currentFilter.classList.contains("active") ? currentFilter.classList.remove("active") : currentFilter.classList.add("active");
      this.querySelectorAll(`.jsLocationFilter[data-filter-value="${value}"]`).forEach((item) => {
        item.classList.toggle("active", currentFilter.classList.contains("active"));
      });
      this.querySelectorAll(`.jsStoreItem[data-location-type="${value}"]`)?.forEach((item) => {
        item.classList.toggle("hidden", !currentFilter.classList.contains("active"));
      });
    }
    onStoreClick(el) {
      if (!el.closest(".jsStoreItem") || el.closest(".jsClose"))
        return;
      const target = el.closest(".jsStoreItem");
      target.classList.add("active");
      window.matchMedia("(min-width: 768px)").matches && this.mapEl.setCenter(+target.dataset.lat, +target.dataset.lng);
      const { lat, lng } = target.dataset;
      target.querySelector(".jsStoreDetail").classList.add("active");
      document.body.classList.remove("on_sm:overflow-hidden");
      window.matchMedia("(max-width: 768px)").matches && document.body.classList.add("on_sm:overflow-hidden");
      this.mapEl.setCenter(+lat, +lng);
    }
    onSearchType() {
      const value = this.querySelector(".jsLocationSearchInput").value;
      if (value.length == 0) {
        this.querySelectorAll(".jsStoreItem.hidden").forEach((item) => item.classList.remove("hidden"));
        this.classList.remove("search-distance");
        this.querySelector(".search-no-result").classList.remove("hidden");
        return;
      }
      this.mapEl.getSuggestions(value);
    }
    async calculateDistance(latitude1, longitude1, latitude2, longitude2) {
      const config = this.mapEl.config;
      const { apiKey } = config;
      const origin = new google.maps.LatLng(latitude1, longitude1);
      const destination = new google.maps.LatLng(latitude2, longitude2);
      if (!this.service) {
        this.service = new google.maps.DistanceMatrixService();
      }
      const request = {
        origins: [origin],
        destinations: [destination],
        travelMode: "DRIVING",
        avoidHighways: false,
        avoidTolls: false
      };
      const response = await this.service.getDistanceMatrix(request);
      const { rows = [] } = response || {};
      const distanceList = rows.map((i) => {
        i.elements.sort((a, b) => {
          return a.distance.value - b.distance.value;
        });
        const nearest = i.elements[0];
        if (nearest.status == "OK")
          return (nearest.distance.value / 1e3 * 0.621371).toFixed(0);
        return null;
      });
      return distanceList[0];
    }
    approximateCalculateDistance(latitude1, longitude1, latitude2, longitude2) {
      const EARTH_RADIUS = 6371e3;
      const METER_TO_MILE = 621371e-9;
      const degreesToRadians = (degrees) => degrees * Math.PI / 180;
      const lat1Radians = degreesToRadians(latitude1);
      const lat2Radians = degreesToRadians(latitude2);
      const deltaLatRadians = degreesToRadians(latitude2 - latitude1);
      const deltaLonRadians = degreesToRadians(longitude2 - longitude1);
      const a = Math.sin(deltaLatRadians / 2) ** 2 + Math.cos(lat1Radians) * Math.cos(lat2Radians) * Math.sin(deltaLonRadians / 2) ** 2;
      const centralAngle = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      const distanceInMeters = EARTH_RADIUS * centralAngle;
      return (distanceInMeters * METER_TO_MILE).toFixed(0);
    }
    async onSearchLocation(el = null, force = false) {
      if (el && !el?.closest(".jsLocationSearchSubmit") && !force)
        return;
      this.mapEl.classList.add("searching");
      const storeWrapperList = this.querySelectorAll(".jsStoreItemsWrapper");
      const value = this.querySelector(".jsLocationSearchInput").value;
      let lat, lng;
      if (value == "Current location") {
        [lat, lng] = this.mapEl.currentLocation;
      } else {
        [lat, lng] = await this.getCoordinatesFromZipcode(value);
      }
      if (!lat && !lng) {
        this.mapEl.classList.remove("searching");
        return;
      }
      window.dispatchEvent(new CustomEvent("map:panTo", {
        detail: {
          latlng: {
            lat,
            lng
          }
        }
      }));
      const data = await this.getStore({
        lat,
        lng
      });
      const { stores, storeHTMLs } = data;
      const storeItems = storeHTMLs.flat(2);
      window.dispatchEvent(new CustomEvent("map:loadMarker", {
        detail: {
          stores
        }
      }));
      storeWrapperList.forEach((wrapper) => {
        wrapper.innerHTML = "";
        storeItems.forEach((store) => {
          wrapper.appendChild(store.cloneNode(true));
        });
      });
      this.querySelectorAll(".jsLocationCount").forEach((item) => {
        item.innerHTML = stores.length;
      });
      this.querySelectorAll(".jsLocationSearch").forEach((item) => {
        item.innerHTML = value;
      });
      this.classList.add("search-distance");
      this.classList.remove("show-store-selected");
      document.querySelectorAll(".jsStoreItem.selected")?.forEach((item) => item.classList.remove("selected"));
      this.mapEl.classList.remove("searching");
    }
    async getCoordinatesFromZipcode(value) {
      const API_KEY = this.mapEl.config.apiKey;
      const geocodeUrl = `https://maps.googleapis.com/maps/api/geocode/json?address=${value}&key=${API_KEY}`;
      const response = await fetch(geocodeUrl);
      const data = await response.json();
      this.querySelector(".search-no-result").classList.add("hidden");
      if (data.results.length > 0) {
        const location = data.results[0].geometry.location;
        return [location.lat, location.lng];
      } else {
        this.classList.remove("search-distance");
        this.querySelector(".search-no-result").classList.remove("hidden");
        console.error(`Invalid Zipcode`);
        return [null, null];
      }
    }
    onScrollTarget(el) {
      if (!el.closest(".jsSectionScroll"))
        return;
      const target = el.closest(".jsSectionScroll");
      const newTarget = document.querySelector(target.dataset.scroll);
      newTarget && Scroll(newTarget);
      this.querySelectorAll(".jsSectionScroll")?.forEach((i) => {
        i.classList.toggle("active", target == i);
      });
    }
    onSuggestClick(el) {
      const suggestContainer = this.querySelector("#locationSuggest");
      const inputSearch = this.querySelector(".jsLocationSearchInput");
      if (el.closest(".jsLocationSearchInput")) {
        suggestContainer.classList.remove("hidden");
        return;
      }
      if (!el.closest("#locationSuggest") && !el.closest(".jsLocationSearchInput")) {
        suggestContainer.classList.add("hidden");
        return;
      }
      const li = el.closest("li");
      if (li) {
        inputSearch.value = li.textContent.trim();
        suggestContainer.classList.add("hidden");
        this.onSearchLocation(null, true);
      }
    }
    async getStore(address) {
      const { stores_url, section } = this.config;
      const urls = stores_url.split(",");
      if (this.cacheFetchStore) {
        const { stores: stores2, storeWrapper: storeWrapper2 } = this.cacheFetchStore;
        return this.filterStoreByDistance(stores2, storeWrapper2, address);
      }
      const fetchPromises = urls.map((item) => {
        const [pathname, queryString] = item.split("?");
        const searchParams = new URLSearchParams(queryString);
        searchParams.set("section_id", section);
        const url = `${pathname}?${searchParams.toString()}`;
        return this.callSection(url);
      });
      const results = await Promise.all(fetchPromises);
      const storeHTML = results.map((i) => i.storeHTML).join("");
      const markers = results.map((i) => i.markers).join(",");
      const stores = JSON.parse(`[${markers}]`);
      const storeWrapper = document.createElement("div");
      storeWrapper.innerHTML = storeHTML;
      this.cacheFetchStore = {
        stores,
        storeWrapper
      };
      return this.filterStoreByDistance(stores, storeWrapper, address);
    }
    async callSection(url) {
      const response = await fetch(url);
      const result = await response.text();
      const parts = result.split("<!-- !!! -->");
      return {
        storeHTML: parts[2],
        markers: parts[4]
      };
    }
    async filterStoreByDistance(stores, storeWrapper, { lat: userLat, lng: userLng }) {
      const { config } = this;
      const validStores = (await Promise.all(
        stores.map(async (store) => {
          const { latitude, longitude } = store;
          let distance = this.approximateCalculateDistance(+userLat, +userLng, +latitude, +longitude);
          let isDistanceInvalid = distance !== null ? distance > config.distance : true;
          if (!isDistanceInvalid) {
            distance = await this.calculateDistance(+userLat, +userLng, +latitude, +longitude);
            isDistanceInvalid = distance !== null ? distance > config.distance : true;
          }
          store.distance = distance;
          return !isDistanceInvalid ? store : null;
        })
      )).filter(Boolean);
      validStores.sort((a, b) => {
        return +a.distance - +b.distance;
      });
      const storeHTMLs = validStores.map((store) => {
        const { latitude, longitude, distance } = store;
        const storeItems = [...storeWrapper.querySelectorAll(".jsStoreItem")].filter((i) => {
          const { lat, lng } = i.dataset;
          return +latitude == +lat && +longitude == +lng;
        }).map((storeItem) => {
          storeItem.setAttribute("data-distance", distance);
          storeItem.querySelectorAll(".distance-value").forEach((i) => {
            i.innerHTML = distance != null ? `${distance}Mi` : null;
          });
          storeItem.querySelectorAll(".store-direction").forEach((i) => {
            const googleMapsDirectionsUrl = `https://www.google.com/maps/dir/?api=1&origin=${userLat},${userLng}&destination=${latitude},${longitude}&travelmode=driving`;
            i.setAttribute("href", googleMapsDirectionsUrl);
          });
          storeItem.classList.toggle("distance-invalid", false);
          return storeItem;
        });
        return storeItems;
      });
      return {
        stores: validStores,
        storeHTMLs
      };
    }
  });

  // app/scripts/common/component/LocationSections.js
  if (!window.customElements.get("location-sections")) {
    customElements.define("location-sections", class extends HTMLElement {
      async connectedCallback() {
        const { section } = this.dataset;
        const urls = this.textContent.split(",");
        const fetchPromises = urls.map((item) => {
          const [pathname, queryString] = item.split("?");
          const searchParams = new URLSearchParams(queryString);
          searchParams.set("section_id", section);
          const url = `${pathname}?${searchParams.toString()}`;
          return this.callSection(url);
        });
        const results = await Promise.all(fetchPromises);
        const HTMLs = results.map((i) => i.storeHTML).join("");
        const markers = results.map((i) => i.markers).join(",");
        document.querySelectorAll(".jsStoreItemsWrapper").forEach((wrapper) => {
          wrapper.innerHTML = HTMLs;
        });
        window.dispatchEvent(new CustomEvent("marker:loaded", {
          detail: {
            stores: JSON.parse(`[${markers}]`)
          }
        }));
      }
      async callSection(url) {
        const response = await fetch(url);
        const result = await response.text();
        const parts = result.split("<!-- !!! -->");
        return {
          storeHTML: parts[2],
          markers: parts[4]
        };
      }
    });
  }

  // app/scripts/common/component/StoreDescription.js
  if (!window.customElements.get("store-description")) {
    customElements.define(
      "store-description",
      class extends HTMLElement {
        constructor() {
          super();
          this.hasProcessed = false;
          this.setupIntersectionObserver();
        }
        connectedCallback() {
          if (!this.hasProcessed) {
            this.setupIntersectionObserver();
          }
        }
        disconnectedCallback() {
          if (this.observer) {
            this.observer.disconnect();
          }
        }
        setupIntersectionObserver() {
          if (this.hasProcessed || !window.IntersectionObserver) {
            this.processContent();
            return;
          }
          const observerOptions = {
            root: null,
            // Use viewport as root
            rootMargin: "50px",
            // Trigger 50px before element enters viewport
            threshold: 0.1
            // Trigger when 10% of element is visible
          };
          this.observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting && !this.hasProcessed) {
                this.processContent();
                this.hasProcessed = true;
                this.observer.disconnect();
              }
            });
          }, observerOptions);
          this.observer.observe(this);
        }
        processContent() {
          const content = this.innerHTML;
          if (!content.trim()) {
            return;
          }
          let processedContent;
          if (content.includes("&lt;") || content.includes("&gt;")) {
            processedContent = this.unescapeHtml(content);
          } else if (!/<[a-z][\s\S]*>/i.test(content) && content.includes("\n")) {
            processedContent = content.replace(/\n/g, "<br>");
          } else {
            processedContent = content;
          }
          if (this.innerHTML !== processedContent) {
            this.innerHTML = processedContent;
          }
        }
        unescapeHtml(text) {
          if (!text)
            return "";
          const textarea = document.createElement("textarea");
          textarea.innerHTML = text;
          let result = textarea.value;
          const entityMap = {
            "&lt;": "<",
            "&gt;": ">",
            "&amp;": "&",
            "&quot;": '"',
            "&#39;": "'",
            "&#x27;": "'",
            "&#x2F;": "/",
            "&#x60;": "`",
            "&#x3D;": "="
          };
          let manualResult = text;
          for (const [entity, char] of Object.entries(entityMap)) {
            manualResult = manualResult.replace(new RegExp(entity, "g"), char);
          }
          return result !== text ? result : manualResult;
        }
      }
    );
  }
})();
